export const ROUTES = {
  INSTRUCTIONS: '/',
  CALENDAR: '/calendar',
  ANALYTICS: '/analytics',
  REPORTS: '/reports',
  API_KEYS: '/api-keys',
  CHAT: '/chat',
  AGENTS: '/agents',
  SUPPORT: '/support',
};
